export default __webpack_public_path__ + "static/media/ISCO CLASS-3_SYLLABUS_2025-26.03cd98d0.pdf";